import React from 'react'
import { node, string } from 'prop-types'
import styled from '@emotion/styled'
import theme from 'theme.json'

const sizes = {
  small: {
    font: '8px',
    padding: '4px',
  },
  medium: {
    font: '12px',
    padding: '8px',
  },
  large: {
    font: '18px',
    padding: '12px',
  },
}

const StyledPill = styled.div`
  background-color: ${({ backgroundColor }) => backgroundColor};
  border-radius: 999px;
  color: ${({ color }) => color};
  font-size: ${({ size }) => sizes[size].font};
  padding: ${({ size }) => sizes[size].padding};
  width: auto;
  display: inline;
`

const Pill = ({
  backgroundColor, color, size, children,
}) => (
  <StyledPill size={size} color={color} backgroundColor={backgroundColor}>
    {children}
  </StyledPill>
)

Pill.propTypes = {
  backgroundColor: string,
  color: string,
  size: string,
  children: node.isRequired,
}

Pill.defaultProps = {
  backgroundColor: 'white',
  color: theme.colors.black,
  size: 'medium',
}

export default Pill
